import { Component, ElementRef, OnInit, TemplateRef, ViewChild, ContentChild, OnDestroy } from '@angular/core';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { Router } from '@angular/router';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { CommonUtil } from 'src/app/core/Utils/common-util';
import { Subscription } from 'rxjs';
import { ProfileService } from './profile.service';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { TranslateService } from '@ngx-translate/core';
import { HaloModalService } from 'src/app/core/halo-modal/halo-modal.service';
import { HaloModalSize } from 'src/app/core/halo-modal/halo-modal-interface';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { CheckSsoEnabledService } from '../services/check-sso-enabled.service';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { MultiFacilityService } from '../services/multi-facility.service';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { UserLogoutService } from '../services/user-logout.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  host: {
    '(@openClose.done)': 'captureDoneEvent($event)',
  },
  animations: [
    trigger('openClose', [
      state('start', style({ width: '0' })),
      state('done', style({ width: '100%' })),
      transition('start => done', animate(3000)),
    ]),
  ],
})
export class ProfileComponent implements OnInit, OnDestroy {
  @ViewChild('fileDropRef', { static: false }) fileDropRef: ElementRef;
  @ViewChild('titleTemplate') titleTemplate: TemplateRef<any>;
  @ViewChild('titleDeleteTemplate') titleDeleteTemplate: TemplateRef<any>;
  @ViewChild('titleConfrmTemplate') titleConfrmTemplate: TemplateRef<any>;
  @ViewChild('footerTemplate') footerTemplate: TemplateRef<any>;
  @ViewChild('footerDeleteTemplate') footerDeleteTemplate: TemplateRef<any>;
  @ViewChild('footerConfirmTemplate') footerConfirmTemplate: TemplateRef<any>;
  @ViewChild('croppingTemplate') croppingTemplate: TemplateRef<any>;
  @ViewChild('deleteTemplate') deleteTemplate: TemplateRef<any>;
  @ViewChild('confirmationTemplate') confirmationTemplate: TemplateRef<any>;
  @ContentChild('uploadedImage', { static: false }) uploadedImage: ElementRef<any>;
  isOpen = false;
  profileForm: FormGroup;
  commonUtil: CommonUtil;
  rootScopeData: RootScopeDeclare;
  lastCroppedImage: ImageCroppedEvent;
  initialState: any;
  files: any;
  showOptionList = false;
  isHiddenPassword = true;
  isNewHiddenPassword = true;
  isReTypeNewHiddenPassword = true;
  isChangedPersonalInfo = false;
  isShowReCaptcha = false;
  isSelectedReCaptcha = false;
  showCropping = false;
  isValidFormat = true;
  isChangedUserId = false;
  isChangedEmail = false;
  isValidSize = true;
  isEnabledUploadImageButton = false;
  isCalledValidate = false;
  selectedFile = null;
  profileDefaultImage = environment.cloudBasePath + '/Icons/LFC_Icon_ProfileDefault_50x50.png';
  profileImage: any;
  uploadedProfilePhotoData: any;
  selectedImageUrl: any = null;
  smallImageUrl: any = null;
  correctCurrentPassword = '';
  newPassword = '';
  showProgressLoader = true;
  isEnabledCancelButton = false;
  isPasswordValid = 'true';
  state = 'start';
  cropperMinWidth = 140;
  cropperMinHeight = 140;
  isSmallerImage = false;
  currentPassword = new FormControl(null);
  private sub = new Subscription();
  languageList = [
    { name: 'British English', value: 'en' },
    { name: 'US English', value: 'en_US' },
    { name: 'Français', value: 'fr' },
    { name: 'Deutsch', value: 'de' },
    { name: 'Nederlands', value: 'nl' },
    { name: 'Español', value: 'es' },
  ];
  partialTranslateLanguageList = [
    { name: 'Italiano', value: 'it' },
    { name: '日本語', value: 'ja' },
    { name: '简体中文', value: 'zh' },
    { name: 'Português', value: 'pt' },
    { name: 'Pусский', value: 'ru' },
    { name: 'Türkçe', value: 'tr' },
    { name: 'Català', value: 'ca' },
    { name: 'Euskara', value: 'eu' },
    { name: 'Suomi', value: 'fi' },
    { name: 'Magyar', value: 'hu' },
    { name: '한국어', value: 'ko' },
    { name: 'Polski', value: 'pl' },
    { name: '繁體中文', value: 'zhl' },
    { name: 'Cymraeg', value: 'cy' },
    { name: 'العربية', value: 'ar' },
    { name: 'עִברִית', value: 'he' },
  ];

  constructor(
    private rootScopeService: RootScopeService,
    private _router: Router,
    private _toast: HaloToastService,
    private _commonUtil: CommonUtil,
    private _profileService: ProfileService,
    private _loader: HaloLoaderService,
    private _modal: HaloModalService,
    private _translate: TranslateService,
    private checkSsoEnabledService: CheckSsoEnabledService,
    private cookieService: CookieService,
    private _facilityService: FacilityService,
    private multiFacService: MultiFacilityService,
    private authenticationService: AuthenticationService,
    private userLogoutService: UserLogoutService,
    private _amplitudeAnalytics: AmplitudeAnalyticsService
  ) {
    this.commonUtil = this._commonUtil;
  }

  ngOnInit() {
    this._initialProfileForm();
    this._getRootScopeData();
    this._setPageName();
    this._trackingPersonalInfo();
    this._trackingNewPassword();
    this._trackingCurrentPassword();
    this._trackingUserId();
    this._trackingEmail();
  }

  changeCheck(control: string): void {
    (this.profileForm.controls.infoGroup as FormGroup).controls[control].patchValue(
      !this.profileForm.value.infoGroup[control]
    );
  }

  changeUnits(value: string): void {
    (this.profileForm.controls.infoGroup as FormGroup).controls.unitsOfMeasure.patchValue(value);
  }

  changeLanguage(language: string, event: Event): void {
    event.stopPropagation();
    (this.profileForm.controls.infoGroup as FormGroup).controls.language.patchValue(language);
    this.showOptionList = false;
  }

  onCaptchaStatusChange(event: any): void {
    if (event === 'success') {
      this.isSelectedReCaptcha = true;
      this.isChangedPersonalInfo = true;
    }
    if (event === 'expired') {
      this.isSelectedReCaptcha = false;
      this.isChangedPersonalInfo = false;
    }
  }

  navigateToBack(): void {
    if (this.rootScopeData.isPageHasUnsavedChanges) {
      this.rootScopeData.pathToNavigate = '/dashboard';
      this.rootScopeData.showUnSavedChangesModal = true;
    } else {
      this._router.navigate(['/dashboard']);
    }
  }

  hideCroppingRibbon(event: any): void {
    if (
      !event?.relatedTarget?.className.includes('img-action') &&
      !event?.relatedTarget?.className.includes('image-edit-icon')
    ) {
      this.showCropping = false;
    }
  }

  openCroppingImageModal(): void {
    this._modal.add({
      dismissible: true,
      titleUppercase: true,
      modalSize: HaloModalSize.Large,
      titleTemplate: this.titleTemplate,
      footerTemplate: this.footerTemplate,
      bodyTemplate: this.croppingTemplate,
      isVideoTree: false,
    });
    if (this.files) {
      this.selectedFile = this.files[0];
      this.selectedImageUrl = null;
    } else {
      this.selectedFile = null;
      this.selectedImageUrl = (this.rootScopeData.currentUser as any).userImage?.sourceImageUrl;
      this.smallImageUrl = (this.rootScopeData.currentUser as any).userImage?.sourceImageUrl;
    }
    // TODO: change this
    setTimeout(() => {
      this.state = 'done';
    }, 500);
  }

  imageCropped(event: ImageCroppedEvent) {
    this.lastCroppedImage = event;
  }

  imageLoaded(event: any): void {
    this.isSmallerImage =
      this.cropperMinWidth > event.original.size.width || this.cropperMinHeight > event.original.size.height
        ? true
        : false;
  }

  cancelOnModal(type?: string): void {
    this._modal.close();
    this.isCalledValidate = false;
    this.correctCurrentPassword = '';
    this.currentPassword.reset();
    this.showProgressLoader = false;
    if (!type) {
      this.files = null;
      this.cancel('upload');
    }
  }

  confirmOnModal(): void {
    this._modal.close();
    this.isEnabledUploadImageButton = true;
    this.profileImage = !this.isSmallerImage ? this.lastCroppedImage.base64 : this.smallImageUrl;
    this.rootScopeData.isPageHasUnsavedChanges = true;
  }

  onChooseFile(): void {
    this.isSmallerImage = false;
    this.fileDropRef.nativeElement.click();
  }

  fileBrowseHandler(files: any) {
    if (files && files[0]) {
      this.isValidFormat = true;
      this.isValidSize = true;
      this.files = files;
      const fileExtension = this.files[0].name.substr(this.files[0].name.lastIndexOf('.') + 1).toUpperCase();
      if (this._isValidFormat(fileExtension)) {
        this.isValidFormat = false;
        return;
      }
      const fileSize = this.files[0].size;
      const maxSize = 10485760;
      if (fileSize > maxSize) {
        this.isValidSize = false;
        return;
      }

      if (this.isValidFormat && this.isValidSize) {
        const formData = new FormData();
        formData.append('file', this.files[0]);
        this.openCroppingImageModal();
        this._profileService.uploadProfilePhoto(formData).subscribe((data: any) => {
          this.uploadedProfilePhotoData = data;
          this.smallImageUrl = this.uploadedProfilePhotoData?.sourceImageURL;
        });
      }
    }
  }

  animEnd(event: any): void {
    if (event.toState === 'done') {
      this.showProgressLoader = false;
    }
  }

  previewClick(type: number): void {
    if (type === 1) {
      this.isHiddenPassword = !this.isHiddenPassword;
    } else if (type === 2) {
      this.isNewHiddenPassword = !this.isNewHiddenPassword;
    } else {
      this.isReTypeNewHiddenPassword = !this.isReTypeNewHiddenPassword;
    }
  }

  update(type: string): void {
    if (type === 'info') {
      if (this.isChangedUserId || this.isChangedEmail) {
        this._modal.add({
          dismissible: true,
          titleUppercase: true,
          modalSize: HaloModalSize.Medium,
          titleTemplate: this.titleConfrmTemplate,
          footerTemplate: this.footerConfirmTemplate,
          bodyTemplate: this.confirmationTemplate,
          isVideoTree: false,
        });
      } else {
        this.updatePersonalInfo();
      }
    } else if (type === 'password') {
      this._updatePassword();
    } else {
      this._updateProfilePhoto();
    }
    this.rootScopeData.isPageHasUnsavedChanges = false;
  }

  cancel(type: string): void {
    if (type === 'password') {
      this.profileForm.controls.passwordGroup.reset();
    } else if (type === 'info') {
      this.profileForm.controls.infoGroup.patchValue(this.initialState);
      this.isChangedPersonalInfo = false;
      this.isSelectedReCaptcha = false;
      this.isShowReCaptcha = false;
      this.isEnabledCancelButton = false;
      this.isChangedUserId = false;
      this.isChangedEmail = false;
      this.isCalledValidate = false;
      this.correctCurrentPassword = '';
      this.currentPassword.reset();
    } else {
      this.files = null;
      this.isSmallerImage = this._checkIsSmallerImage();
      this.uploadedProfilePhotoData = null;
      this.fileDropRef.nativeElement.value = null;
      this.isEnabledUploadImageButton = false;
      this.profileImage = (this.rootScopeData?.currentUser as any).userImage?.thumbnailUrl;
    }
    this.rootScopeData.isPageHasUnsavedChanges = false;
  }

  updatePersonalInfoWithCheckingEmail(): void {
    const body = {
      emailAddress: this.initialState.email,
      password: btoa(unescape(encodeURIComponent(this.currentPassword.value))),
    };
    const validatePassword = this._profileService.validatePassword(body).subscribe((data: any) => {
      this.isPasswordValid = data.isPasswordValid;
      this.isCalledValidate = true;
      if (this.isPasswordValid === 'true') {
        this.updatePersonalInfo();
        this.correctCurrentPassword = this.currentPassword.value;
        this.rootScopeData.isPageHasUnsavedChanges = false;
      } else {
        this.correctCurrentPassword = '';
        this.currentPassword.setErrors({ wrongPass: true });
      }
    });
    this.sub.add(validatePassword);
  }

  updatePersonalInfo(): void {
    this.isChangedUserId = false;
    this.isChangedEmail = false;
    const body = {
      emailAddress: this.profileForm.value.infoGroup.email,
      emailNotificationsOK: this.profileForm.value.infoGroup.emailNotificationsOK,
      firstName: this.profileForm.value.infoGroup.firstName,
      lastName: this.profileForm.value.infoGroup.lastName,
      nickName: this.profileForm.value.infoGroup.userId,
      optinResearch: this.profileForm.value.infoGroup.optinResearch,
      preferredLanguage: this.profileForm.value.infoGroup.language.value,
      preferredUnit: this.profileForm.value.infoGroup.unitsOfMeasure,
    };
    this._loader.startProcess();
    this._profileService.updatePersonalInfo(body).subscribe(
      () => {
        this.isShowReCaptcha = false;
        this._setRootScopeData(body);
        this._selectLanguage(body.preferredLanguage);
        this._setInitialState();
        this.isChangedPersonalInfo = false;
        this.isEnabledCancelButton = false;
        this.isCalledValidate = false;
        this._modal.close();
        this._loader.endProcess();
        this.currentPassword.reset();
      },
      (errorResponse: any) => {
        if (errorResponse.error.includes('Email Exists')) {
          (this.profileForm.controls.infoGroup as FormGroup).controls.email.setErrors({ emailExist: true });
        } else if (errorResponse.error.includes('Nickname Exists')) {
          (this.profileForm.controls.infoGroup as FormGroup).controls.userId.setErrors({ nickNameExist: true });
        }
        this._modal.close();
        this._loader.endProcess();
      }
    );
  }

  openDeleteAccount(): void {
    this._modal.add({
      dismissible: true,
      titleUppercase: true,
      modalSize: HaloModalSize.Medium,
      titleTemplate: this.titleDeleteTemplate,
      footerTemplate: this.footerDeleteTemplate,
      bodyTemplate: this.deleteTemplate,
      isVideoTree: false,
    });
  }

  deleteAccount(): void {
    this._modal.close();
    this._loader.startProcess();
    this._amplitudeAnalytics.logEvent({ elementName: 'Delete', action: 'Click' });
    this._profileService.deleteAccount().subscribe(
      () => {
        this.signOut();
        this._loader.endProcess();
      },
      () => this._loader.endProcess()
    );
  }

  isSSOEnabled = false;

  signOut(): void {
    let vtToken;
    this.isSSOEnabled = false;
    if (sessionStorage.getItem('vtTokenKey')) {
      vtToken = sessionStorage.getItem('vtTokenKey');
    } else {
      vtToken = localStorage.getItem('vtTokenKey');
    }
    if (vtToken) {
      this._loader.startProcess();
      this.checkSsoEnabledService.checkSSOEnabled(vtToken).subscribe(
        (data: any) => {
          if (data.source === 'SSO') {
            this.isSSOEnabled = true;
          }
          this.getUserLogout();
        },
        (error: any) => {
          this.getUserLogout();
        }
      );
    }
  }

  getUserLogout(): void {
    const ssoRedirectionParams = encodeURIComponent(
      '?end_url=' + environment.currentHostPath + '/halo.html#/login?lang=' + localStorage.getItem('selectedLang')
    );
    this.userLogoutService.userLogout().subscribe(
      (data: any) => {
        if (this.isSSOEnabled) {
          this.afterLogout();
          window.location.href =
            environment.oamHostPath + '/oam/server/logout' + decodeURIComponent(ssoRedirectionParams);
        } else {
          this.afterLogout();
          this.authenticationService.signoutReset();
          this.multiFacService.resetMultiFacilitiesList();
          this._facilityService.reset();
          this._loader.endProcess();
          this._router.navigate(['/login']);
        }
      },
      (error: any) => {
        this.afterLogout();
        this.authenticationService.signoutReset();
        this.multiFacService.resetMultiFacilitiesList();
        this._facilityService.reset();
        this._loader.endProcess();
        this._router.navigate(['/login']);
      }
    );
  }

  afterLogout() {
    this.clearStorageAndCookies();
    this.rootScopeData.isAuthenticated = false;
  }

  clearStorageAndCookies(): void {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('vtTokenKey');
    localStorage.removeItem('vtUserType');
    localStorage.removeItem('vtManagerType');
    localStorage.removeItem('ssoFederated');
    localStorage.removeItem('newEquipmentAdded');
    localStorage.removeItem('isSsoFederated');
    localStorage.removeItem('lefNavigationExpandStatus');

    sessionStorage.removeItem('vtTokenKey');
    sessionStorage.removeItem('hideSurveyPopup');
    sessionStorage.removeItem('hideOutdatedOnboardingPopup');

    this.cookieService.delete('vtTokenKey');
    this.cookieService.delete('ssoCookie');
    this.cookieService.delete('ssoFederated');
    this.cookieService.delete('ssolang');
    this.cookieService.delete('vtManagerType');
    this.cookieService.delete('vtUserType');
    this.cookieService.delete('isSsoFederated');
    this.cookieService.delete('vtImpersonatorTokenKey');

    setTimeout(() => {
      this._facilityService.reset();
    }, 3000);
  }

  private _updateProfilePhoto(): void {
    const img = (this.rootScopeData?.currentUser as any).userImage;
    const body = {
      contentType: this.files && this.files[0].type ? this.files[0].type : 'image/' + img.contentType,
      originalFileName: this.files && this.files[0].name ? this.files[0].name : img.originalFileName,
      s3ObjectKey: this.uploadedProfilePhotoData ? this.uploadedProfilePhotoData.sourceImageKey : img.s3ObjectKey,
      sourceImageUrl: this.uploadedProfilePhotoData ? this.uploadedProfilePhotoData.sourceImageURL : img.sourceImageUrl,
      croppingParam: {
        uiW: !this.isSmallerImage ? this.lastCroppedImage.width : 0,
        uiH: !this.isSmallerImage ? this.lastCroppedImage.height : 0,

        uiX: !this.isSmallerImage ? this.lastCroppedImage.cropperPosition.x1 : 0,
        uiY: !this.isSmallerImage ? this.lastCroppedImage.cropperPosition.y2 : 0,
        X: !this.isSmallerImage ? this.lastCroppedImage.imagePosition.x1 : 0,
        Y: !this.isSmallerImage ? this.lastCroppedImage.imagePosition.y1 : 0,
        H: !this.isSmallerImage ? this.lastCroppedImage.height : 0,
        W: !this.isSmallerImage ? this.lastCroppedImage.width : 0,
      },
    };
    this._loader.startProcess();
    const updatePhoto = this._profileService.updateProfilePhoto(body).subscribe(
      (response: any) => {
        this._loader.endProcess();
        this.rootScopeData.profileImageUrl = this.profileImage;
        this.isEnabledUploadImageButton = false;
        if ((this.rootScopeData?.currentUser as any).userImage) {
          (this.rootScopeData?.currentUser as any).userImage.thumbnailUrl = this.profileImage;
          (this.rootScopeData?.currentUser as any).userImage.croppingParam = response.croppingParam;
        } else {
          (this.rootScopeData.currentUser as any) = {
            ...this.rootScopeData.currentUser,
            userImage: {
              ...response,
            },
          };
        }
      },
      () => this._loader.endProcess()
    );
    this.sub.add(updatePhoto);
  }

  private _updatePassword(): void {
    const body = {
      firstName: this.profileForm.value.infoGroup.firstName,
      lastName: this.profileForm.value.infoGroup.lastName,
      password: btoa(unescape(encodeURIComponent(this.profileForm.value.passwordGroup.newPassword))),
    };
    this._loader.startProcess();
    this._profileService.updatePassword(body).subscribe(
      () => {
        this.profileForm.controls.passwordGroup.reset();
        this.rootScopeData.isPageHasUnsavedChanges = false;
        this._toast.creatToast(this._commonUtil.translateText('ACCOUNT.UPDATE.MESSAGE.PASSWORD'));
        this._loader.endProcess();
      },
      () => this._loader.endProcess()
    );
  }

  private _initialProfileForm(): void {
    this.profileForm = new FormGroup({
      infoGroup: new FormGroup({
        firstName: new FormControl(null, Validators.required),
        lastName: new FormControl(null, Validators.required),
        unitsOfMeasure: new FormControl('I', Validators.required),
        language: new FormControl(this.languageList[0], Validators.required),
        userId: new FormControl(null, [Validators.required, Validators.minLength(4)]),
        email: new FormControl(null, [Validators.required, Validators.email]),
        optinResearch: new FormControl(false, Validators.required),
        emailNotificationsOK: new FormControl(false, Validators.required),
      }),
      passwordGroup: new FormGroup({
        currentPassword: new FormControl(null, Validators.required),
        newPassword: new FormControl(null, [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(15),
          validateLeastOneNumber(),
          validateLeastOneUppercaseOrLowercase(),
          validateLeastOneSpecialCharacter(),
          this.validatePasswordSameAsCurrent(),
        ]),
        reTypePassword: new FormControl(null, [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(15),
          validateLeastOneNumber(),
          validateLeastOneUppercaseOrLowercase(),
          validateLeastOneSpecialCharacter(),
          this.validatePasswordSameAsNew(),
        ]),
      }),
    });
  }

  private _getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
      this.isSmallerImage = this._checkIsSmallerImage();
      this.profileImage = (this.rootScopeData?.currentUser as any).userImage?.thumbnailUrl;
      this._patchForm();
      this._setInitialState();
    });
  }

  _patchForm(): void {
    this.profileForm.controls.infoGroup.patchValue(this._setDefaultValue());
  }

  private _checkIsSmallerImage(): boolean {
    const param = (this.rootScopeData?.currentUser as any).userImage?.croppingParam;
    return (
      param &&
      param.H === '0' &&
      param.W === '0' &&
      param.X === '0' &&
      param.Y === '0' &&
      param.uiX === '0' &&
      param.uiY === '0' &&
      param.uiH === '0' &&
      param.uiW === '0'
    );
  }

  private _setInitialState(): void {
    this.initialState = JSON.parse(JSON.stringify(this._setDefaultValue()));
  }

  private _setDefaultValue() {
    return {
      firstName: this.rootScopeData.currentUser.firstName,
      lastName: this.rootScopeData.currentUser.lastName,
      unitsOfMeasure: this.rootScopeData.currentUser.preferredUnit,
      language: this._getLanguage(),
      userId: this.rootScopeData.currentUser.nickName ?? '',
      email: this.rootScopeData.currentUser.emailAddress,
      optinResearch: (this.rootScopeData.currentUser as any).optinResearch === 'true',
      emailNotificationsOK: (this.rootScopeData.currentUser as any).emailNotificationsOK === 'true',
    };
  }

  private _setPageName(): void {
    this.rootScopeData.pageName = 'profile';
  }

  private _isValidFormat(fileExtension: string): boolean {
    return (
      fileExtension !== 'GIF' &&
      fileExtension !== 'PNG' &&
      fileExtension !== 'BMP' &&
      fileExtension !== 'JPG' &&
      fileExtension !== 'JPEG'
    );
  }

  private _getLanguage() {
    const selectedLanguage = this.languageList.find(
      (item) => item.value === this.rootScopeData.currentUser.preferredLanguage
    );
    if (selectedLanguage) {
      return selectedLanguage;
    }
    return this.partialTranslateLanguageList.find(
      (item) => item.value === this.rootScopeData.currentUser.preferredLanguage
    );
  }

  private _trackingPersonalInfo(): void {
    const personalChanged = this.profileForm.valueChanges.subscribe(() => {
      if (JSON.stringify(this.initialState) !== JSON.stringify(this.profileForm.value.infoGroup)) {
        this.rootScopeData.isPageHasUnsavedChanges = true;
      }
      (this.profileForm.controls.infoGroup as FormGroup).controls.userId.markAsTouched();
      Object.keys(this.initialState).forEach((key) => {
        if (key === 'language') {
          if (this.initialState[key].value !== this.profileForm.value.infoGroup[key].value && !this.isShowReCaptcha) {
            this.isChangedPersonalInfo = true;
          }
        } else {
          if (this.initialState[key] !== this.profileForm.value.infoGroup[key] && !this.isShowReCaptcha) {
            this.isChangedPersonalInfo = true;
          }
        }
      });
    });
    this.sub.add(personalChanged);
  }

  private _trackingCurrentPassword(): void {
    const changeCurrentPassword = (
      this.profileForm.controls.passwordGroup as FormGroup
    ).controls.currentPassword.valueChanges.subscribe((value: any) => {
      if (value) {
        const value = (this.profileForm.controls.passwordGroup as FormGroup).controls.currentPassword.value;
        const isChanged =
          this.profileForm.value.passwordGroup.currentPassword ||
          this.profileForm.value.passwordGroup.newPassword ||
          this.profileForm.value.passwordGroup.reTypePassword;
        if (isChanged) {
          this.rootScopeData.isPageHasUnsavedChanges = true;
        }
        const body = {
          emailAddress: this.initialState.email,
          password: btoa(unescape(encodeURIComponent(value))),
        };
        const validatePassword = this._profileService.validatePassword(body).subscribe((data: any) => {
          this.isPasswordValid = data.isPasswordValid;
          if (this.isPasswordValid === 'true') {
            this.correctCurrentPassword = value;
          }
        });
        this.sub.add(validatePassword);
      }
    });
    this.sub.add(changeCurrentPassword);
  }

  private _trackingNewPassword(): void {
    const changeNewPassword = (
      this.profileForm.controls.passwordGroup as FormGroup
    ).controls.newPassword.valueChanges.subscribe((newPassword: string) => {
      this.rootScopeData.isPageHasUnsavedChanges = true;
      this.newPassword = newPassword;
      const isTouched = (this.profileForm.controls.passwordGroup as FormGroup).controls.reTypePassword.touched;
      if (isTouched) {
        (this.profileForm.controls.passwordGroup as FormGroup).controls.reTypePassword.updateValueAndValidity();
        (this.profileForm.controls.passwordGroup as FormGroup).controls.reTypePassword.markAsTouched();
      }
    });
    this.sub.add(changeNewPassword);
  }

  private _trackingUserId(): void {
    const changeUserId = (this.profileForm.controls.infoGroup as FormGroup).controls.userId.valueChanges.subscribe(
      () => {
        this.isChangedUserId = true;
        this.isEnabledCancelButton = true;
        if (!this.isSelectedReCaptcha) {
          this.isShowReCaptcha = true;
          this.isChangedPersonalInfo = false;
        }
      }
    );
    this.sub.add(changeUserId);
  }

  private _trackingEmail(): void {
    const changeEmail = (this.profileForm.controls.infoGroup as FormGroup).controls.email.valueChanges.subscribe(() => {
      this.isEnabledCancelButton = true;
      this.isChangedEmail = true;
      if (!this.isSelectedReCaptcha) {
        this.isShowReCaptcha = true;
        this.isChangedPersonalInfo = false;
      }
    });
    this.sub.add(changeEmail);
  }

  private _selectLanguage(langCode: string) {
    this.rootScopeData.translationsLoaded = false;
    this.rootScopeData.selectedLang = langCode;
    localStorage.setItem('selectedLang', langCode);
    this._translate.use(this.rootScopeData.selectedLang).subscribe(() => {
      this.rootScopeData.translationsLoaded = true;
    });
    if (this.rootScopeData.selectedLang === 'ar' || this.rootScopeData.selectedLang === 'he') {
      this.rootScopeService.changeToRtl();
    } else {
      this.rootScopeService.changeToLtr();
    }
  }

  private _setRootScopeData(data: any): void {
    this.rootScopeData.currentUser.firstName = data.firstName;
    this.rootScopeData.currentUser.lastName = data.lastName;
    this.rootScopeData.currentUser.preferredUnit = data.preferredUnit;
    this.rootScopeData.currentUser.preferredLanguage = data.preferredLanguage;
    this.rootScopeData.currentUser.nickName = data.nickName;
    this.rootScopeData.currentUser.emailAddress = data.emailAddress;
    (this.rootScopeData.currentUser as any).optinResearch = data.optinResearch ? 'true' : 'false';
    (this.rootScopeData.currentUser as any).emailNotificationsOK = data.emailNotificationsOK ? 'true' : 'false';
  }

  validatePasswordSameAsCurrent(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const validPassword = control.value && control.value !== this.correctCurrentPassword;
      return !validPassword ? { isSame: true } : null;
    };
  }

  validatePasswordSameAsNew(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const validPassword = control.value && control.value === this.newPassword;
      return !validPassword ? { isSame: true } : null;
    };
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}

export function validateLeastOneNumber(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const validPassword = /[0-9]+/.test(control.value);
    return !validPassword ? { leastOneNumber: true } : null;
  };
}

export function validateLeastOneUppercaseOrLowercase(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const upperCaseOrUpperCaseCheck = /[A-Za-z]/.test(control.value);
    const validPassword = upperCaseOrUpperCaseCheck && control.value;
    return !validPassword ? { uppercaseOrLowercase: true } : null;
  };
}

export function validateLeastOneSpecialCharacter(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const validPassword = /[*@!#$%&()^]/.test(control.value);
    return !validPassword ? { leastOneSpecialCharacter: true } : null;
  };
}
